import type { MechKey } from './keys';

export const hi: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'यांत्रिकी · 2D',
  'panel.scene': 'दृश्य',
  'panel.dims': 'मापदंड',
  'panel.style': 'रूप',
  'panel.action': 'नियंत्रण',
  'style.body': 'वस्तु',
  'style.vector': 'सदिश',
  'style.ground': 'भूमि',
  'style.forces': 'बल दिखाएं',
  'style.trace': 'पथ दिखाएं',
  'style.labels': 'सदिश लेबल',
  'hint.line1': 'शुरू करने के लिए Play क्लिक करें · वस्तुओं को खींचें',
  'hint.line2': 'Sandbox: एक आकार चुनें, फिर रखने के लिए क्लिक करें',
  'scene.incline': 'आनत तल',
  'scene.projectile': 'प्रक्षेप्य गति',
  'scene.pendulum': 'लोलक',
  'scene.springMass': 'स्प्रिंग-द्रव्यमान तंत्र',
  'scene.collisions': 'टक्कर',
  'scene.atwood': 'एटवुड मशीन',
  'scene.circular': 'वृत्तीय गति',
  'scene.sandbox': 'सैंडबॉक्स',
  'dim.angle': 'कोण (°)',
  'dim.friction': 'घर्षण',
  'dim.mass': 'द्रव्यमान',
  'dim.massA': 'द्रव्यमान A',
  'dim.massB': 'द्रव्यमान B',
  'dim.velocity': 'वेग',
  'dim.angleLaunch': 'प्रक्षेपण कोण (°)',
  'dim.gravity': 'गुरुत्व',
  'dim.gravityX': 'गुरुत्व x',
  'dim.gravityY': 'गुरुत्व y',
  'dim.length': 'लंबाई',
  'dim.damping': 'अवमंदन',
  'dim.spring': 'कठोरता',
  'dim.restitution': 'प्रत्यावस्थान',
  'dim.radius': 'त्रिज्या',
  'dim.speed': 'चाल',
  'action.play': 'चलाएं',
  'action.pause': 'रोकें',
  'action.step': 'चरण',
  'action.reset': 'रीसेट',
  'action.speed': 'गति',
  'action.clear': 'साफ करें',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'गुरुत्वाकर्षण',
  'forceName.normal': 'अभिलंब बल',
  'forceName.friction': 'घर्षण बल',
  'forceName.tension': 'तनाव',
  'forceName.spring': 'स्प्रिंग बल',
  'forceName.applied': 'आरोपित बल',
  'forceName.air': 'वायु प्रतिरोध',
  'palette.box': 'बक्सा',
  'palette.circle': 'गेंद',
  'palette.ramp': 'ढलान',
  'palette.ground': 'भूमि',
  'palette.hint': 'एक आकार चुनें, फिर रखने के लिए कैनवास पर क्लिक करें।',
  'panel.forces': 'देखे गए बल',
  'forces.empty': 'अभी कोई नहीं — दृश्य चलाएं',
};
